import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogoTitle } from '../classes/LogoTitleContext';
import { ToastContainer } from 'react-toastify';
import Footer from '../Parts/MasterFooter';
import 'react-toastify/dist/ReactToastify.css';
import { ContentContainer, AdvancedCard, AdvancedTableCColumn, AdvancedTableCell, AdvancedTableRow, HeaderContainer, HeaderTitle, FooterContainer, } from '../Styles/MasterDashboard';
import {
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Toolbar,
    Button,
    InputAdornment,
    IconButton,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    Grid, Menu, MenuItem,
} from '@mui/material';
import getAuthHeaders from '../Auth/Authentication';
import { API_ENDPOINTS } from '../Auth/apiConfig';
import axios from 'axios';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import GoToLogin from '../Images/MasterDashboard/redirectTo.png';
import Logout from '../Images/MasterDashboard/Logout.png';
import VaculinkLogo from '../Images/VaculinkIcon/vaculink-logo.png';
import CancelIcon from '@mui/icons-material/Cancel';
import Switch from '@mui/material/Switch';
import CloseIcon from '@mui/icons-material/Close';
import { AccountCircle, Settings as SettingsIcon } from '@mui/icons-material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import LogoutIcon from '@mui/icons-material/Logout';

const MasterDashboard = ({ loggedInUser }) => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const isMenuOpen = Boolean(anchorEl);
    const [isLoggedIn, setIsLoggedIn] = useState(/* initial login state */);
    const { logoUrl } = useLogoTitle();
    const [projects, setProjects] = useState([]);
    const [currentPageOne, setCurrentPageOne] = useState(1);
    const [superAdminUserDetails, setSuperAdminUserDetails] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false); // Edit mode flag
    const [editedData, setEditedData] = useState({
        EmailEnabled: loggedInUser?.EmailEnabled === "true",
        SmsEnabled: loggedInUser?.SmsEnabled === "true",
        projectsEmailService: [],
        projectsSmsService: [],
    });
    const rowsPerPageOne = 6;
    const timeoutRef = useRef(null);

    // Filter projects based on the search term for all relevant fields
    const filteredProjects = projects.filter(project =>
        project.ProjectName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.Location.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.ProjectType.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.DeviceType.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Calculate the index range for the current page based on filtered projects
    const startRowIndexOne = (currentPageOne - 1) * rowsPerPageOne;
    const endRowIndexOne = startRowIndexOne + rowsPerPageOne;
    const paginatedDataOne = filteredProjects.slice(startRowIndexOne, endRowIndexOne);

    // Handle page change event
    const handlePageChangeOne = (event, newPage) => {
        setCurrentPageOne(newPage);
    };

    const handleDetailViewClick = async (customerid) => {
        try {
            // Clear session/local storage data
            sessionStorage.removeItem('isLoggedIn');
            sessionStorage.removeItem('username');
            sessionStorage.removeItem('password');
            sessionStorage.removeItem('loggedInUser');

            // Choose the appropriate API endpoint based on RoleID
            const authHeaders = getAuthHeaders();
            let response;
            if (loggedInUser?.RoleID === 1) {
                // Fetch data for RoleID 1 (response1)
                response = await fetch(`${API_ENDPOINTS.MasterLoginProjectsCredentials}/api/getMasterLoginCredentials/${customerid}`, {
                    headers: authHeaders,
                });
            } else if (loggedInUser?.RoleID === 2) {
                // Fetch data for RoleID 2 (response2)
                response = await fetch(`${API_ENDPOINTS.MasterLoginProjectsCredentials}/api/getAdminMLoginCredentials/${customerid}`, {
                    headers: authHeaders,
                });
            } else {
                throw new Error('Invalid RoleID');
            }

            if (!response.ok) {
                throw new Error('Failed to fetch login credentials');
            }

            const data = await response.json();
            const { username } = data;

            // Get the hardcoded password from the environment variable
            const password = process.env.REACT_APP_MASTERLOGIN_PASSWORD;

            // Store username and password securely in sessionStorage
            sessionStorage.setItem('username', username);
            sessionStorage.setItem('password', password);

            // Redirect to the Login page without exposing credentials in the URL
            const url = `https://www.vaculink.com/Login`;
            window.location.href = url;
        } catch (error) {
            console.error('Error fetching login credentials:', error);
        }
    };

    // Handle logout and navigation
    const handleLogout = () => {
        setIsLoggedIn(false);
        sessionStorage.removeItem('isLoggedIn');
        sessionStorage.removeItem('username');
        window.location.href = '/Login';
    };

    // Handle User Settings Modal open/close
    const handleUserSettingsClick = () => {
        setOpenModal(true); // Open modal when user settings icon is clicked
    };

    const handleModalClose = () => {
        setOpenModal(false); // Close the modal
    };

    const handleEditClick = () => {
        setIsEditMode(true);
    };

    const handleSaveClick = async () => {
        try {
            const { EmailEnabled, SmsEnabled, projectsEmailService, projectsSmsService } = editedData;

            // Filter out the empty or false arrays for EmailProjectsService and SMSProjectsService
            const emailProjectsService = projectsEmailService.filter(project => project.EmailService);  // Only include if EmailService is truthy
            const smsProjectsService = projectsSmsService.filter(project => project.SmsService);  // Only include if SmsService is truthy

            // Prepare the data to send to the API, including only non-empty services
            const dataToSend = {
                email: loggedInUser?.email,  // Assuming this is already available
                RoleID: loggedInUser?.RoleID,  // Assuming this is already available
                EmailEnabled,
                SmsEnabled,
            };

            // Only add the services if they have valid entries
            if (emailProjectsService.length > 0) {
                dataToSend.EmailProjectsService = emailProjectsService;
            }
            if (smsProjectsService.length > 0) {
                dataToSend.SMSProjectsService = smsProjectsService;
            }

            // Get the authorization headers
            const authHeaders = getAuthHeaders();  // Assuming getAuthHeaders() is a function that retrieves auth headers (like a JWT)

            // Make API call to save the data
            const response = await fetch(`${API_ENDPOINTS.SuperAdminSaveUserChanges}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...authHeaders,  // Include authorization headers
                },
                body: JSON.stringify(dataToSend),  // Send only the necessary data
            });

            const result = await response.json();

            if (response.ok) {
                // Handle success - Show a message or perform additional actions
                //console.log('Changes saved successfully:', result);
                setIsEditMode(false); // Exit edit mode after saving
            } else {
                // Handle error - Show an error message
                console.error('Error saving data:', result.message || 'Server error');
            }
        } catch (error) {
            console.error('Error in handleSaveClick:', error);
        }
    };

    const handleCancelClick = () => {
        // Revert back to original state
        setEditedData({
            EmailEnabled: loggedInUser?.EmailEnabled === "true",
            SmsEnabled: loggedInUser?.SmsEnabled === "true",
            projectsEmailService: superAdminUserDetails?.map(project => ({
                ...project,
                EmailService: project.EmailService === "true"
            })),
            projectsSmsService: superAdminUserDetails?.map(project => ({
                ...project,
                SmsService: project.SmsService === "true"
            }))
        });
        setIsEditMode(false);
    };

    const handleSwitchChange = (serviceType, projectIndex, value) => {
        // Handle switch changes for Email/SMS Services
        setEditedData(prevState => {
            const updatedData = { ...prevState };
            if (serviceType === "email") {
                updatedData.projectsEmailService[projectIndex].EmailService = value;
            } else if (serviceType === "sms") {
                updatedData.projectsSmsService[projectIndex].SmsService = value;
            }
            return updatedData;
        });
    };

    useEffect(() => {
        const fetchSuperAdminUserDetails = async () => {
            try {
                const authHeaders = getAuthHeaders();
                const email = loggedInUser?.email;
                const roleID = loggedInUser?.RoleID;
                const ProjectsAssigned = loggedInUser?.ProjectsAssigned;

                //console.log('Logged In User:', loggedInUser);
                //console.log('Request URL:', `${API_ENDPOINTS.SuperAdminLoginUserDetails}?email=${email}&roleID=${roleID}&ProjectsAssigned=${ProjectsAssigned}`);

                const response = await axios.get(`${API_ENDPOINTS.SuperAdminLoginUserDetails}?email=${email}&roleID=${roleID}&ProjectsAssigned=${ProjectsAssigned}`, {
                    headers: authHeaders,
                });

                if (response.status === 200) {
                    //console.log('SuperAdmin User Details:', response.data);
                    setSuperAdminUserDetails(response.data);
                } else {
                    console.error('Failed to fetch SuperAdmin user details. Status:', response.status);
                }
            } catch (error) {
                console.error('Error fetching SuperAdmin user details:', error);
            }
        };
        if (loggedInUser) {
            fetchSuperAdminUserDetails();
        }
    }, [loggedInUser]);

    useEffect(() => {
        if (superAdminUserDetails && loggedInUser) {
            setEditedData({
                EmailEnabled: loggedInUser?.EmailEnabled === "true",
                SmsEnabled: loggedInUser?.SmsEnabled === "true",
                projectsEmailService: superAdminUserDetails.map(project => ({
                    ...project,
                    EmailService: project.EmailService === "true",
                })),
                projectsSmsService: superAdminUserDetails.map(project => ({
                    ...project,
                    SmsService: project.SmsService === "true",
                })),
            });
        }
    }, [superAdminUserDetails, loggedInUser]);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const authHeaders = getAuthHeaders();

                // Ensure ProjectsAssigned is an array. If it's a comma-separated string, convert it to an array
                let projectsAssigned = loggedInUser?.ProjectsAssigned;

                //console.log('Logged In User Data:', loggedInUser);  // Log loggedInUser data

                //console.log('ProjectsAssigned for the authenticated user:', loggedInUser?.ProjectsAssigned);

                if (typeof projectsAssigned === 'string') {
                    // Convert the comma-separated string into an array
                    projectsAssigned = projectsAssigned.split(',').map(id => id.trim());
                }

                //console.log('Projects Assigned:', projectsAssigned);  // Log ProjectsAssigned for debugging

                if (projectsAssigned.length === 0) {
                    console.error('No projects assigned for this user.');
                    return; // Exit early if no projects are assigned
                }

                // Convert the array to a comma-separated string
                const projectsAssignedStr = projectsAssigned.join(',');

                // Fetch data using the API
                const response = await axios.get(`${API_ENDPOINTS.MasterDashboardProjectDetails}?clientIds=${projectsAssignedStr}`, {
                    headers: authHeaders,
                });

                // Check for non-success HTTP status
                if (response.status !== 200) {
                    throw new Error(`Network response was not ok, status MasterDashboardProjectDetails: ${response.status}`);
                }

                // `axios` already parses JSON responses
                const data = response.data;
                setProjects(data);  // Assuming setProjects is a state setter function
            } catch (error) {
                console.error('Failed to fetch projects MasterDashboardProjectDetails:', error);
            }
        };

        fetchProjects();

    }, [loggedInUser]);  // Re-run when loggedInUser changes

    // Clear search input
    const clearSearch = () => {
        setSearchTerm('');
    };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <div style={{ backgroundColor: '#f0f0f0', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <HeaderContainer position="static">
                <Toolbar>
                    {/* Logo on the left */}
                    <img src={VaculinkLogo} alt="Vaculink Logo" style={{ width: '100px', marginRight: '20px' }} />
                    <HeaderTitle>Master Dashboard</HeaderTitle>

                    <Typography
                        variant="h6"
                        style={{
                            marginLeft: 'auto',
                            marginRight: '10px',
                            color: '#206F8B',
                            fontStyle: 'italic',
                            textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
                        }}
                    >
                        <span style={{ fontSize: '16px' }}>Welcome, </span>
                        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
                            {loggedInUser?.username?.split(' ')[0] || 'User'}
                        </span>
                    </Typography>


                    {/* Menu button */}
                    <IconButton
                        color="inherit"
                        onClick={handleMenuOpen}
                        style={{ marginLeft: 'auto' }} // Push menu to the right
                    >
                        <MenuOpenIcon sx={{ fontSize: 35, color: '#1E104B' }} />
                    </IconButton>

                    {/* Dropdown Menu */}
                    <Menu
                        anchorEl={anchorEl}
                        open={isMenuOpen}
                        onClose={handleMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        sx={{
                            '& .MuiPaper-root': {
                                backgroundColor: '#333', // Light black background
                                color: 'white',
                                borderRadius: '16px', // Rounded corners for the menu
                            },
                            '& .MuiMenuItem-root': {
                                transition: 'background-color 0.2s ease',
                                borderRadius: '8px', // Slightly rounded menu items
                                '&:hover': {
                                    backgroundColor: '#444', // Light green hover background
                                    color: 'white',
                                },
                            },
                        }}
                    >
                        {/* Username 
                        <MenuItem disabled>
                            <AccountCircle sx={{ marginRight: '10px' }} />
                            {loggedInUser?.username || 'User'}
                        </MenuItem>
                        */}
                        {/* Settings */}
                        <MenuItem onClick={() => {
                            handleUserSettingsClick();
                            handleMenuClose();
                        }}>
                            <SettingsIcon sx={{ marginRight: '10px', color: '#66bb6a' }} />
                            Settings
                        </MenuItem>

                        {/* Logout */}
                        <MenuItem onClick={() => {
                            handleLogout();
                            handleMenuClose();
                        }}>
                            <LogoutIcon sx={{ marginRight: '10px', color: 'red' }} />
                            Logout
                        </MenuItem>
                    </Menu>
                </Toolbar>
            </HeaderContainer>

            <ContentContainer>
                <AdvancedCard>
                    <TableContainer component={Paper} style={{ background: 'none', boxShadow: 'none' }}>
                        <Box display="flex" justifyContent="space-between" mb={2} mt={1}>
                            <TextField
                                label="Search"
                                variant="filled"
                                size="small"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{ width: '200px', marginRight: '10px', }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={clearSearch} edge="end">
                                                <CancelIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <Stack spacing={2}>
                                <Pagination
                                    count={Math.ceil(projects.length / rowsPerPageOne)}
                                    page={currentPageOne}
                                    onChange={handlePageChangeOne}
                                    variant="outlined"
                                    color="primary"
                                />
                            </Stack>
                        </Box>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <AdvancedTableCColumn>Project name</AdvancedTableCColumn>
                                    <AdvancedTableCColumn>Project Address</AdvancedTableCColumn>
                                    <AdvancedTableCColumn>Project type</AdvancedTableCColumn>
                                    <AdvancedTableCColumn>Device type</AdvancedTableCColumn>
                                    <AdvancedTableCColumn>LoginTo Project</AdvancedTableCColumn>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredProjects.length > 0 ? ( // Check against filteredProjects
                                    paginatedDataOne.map((project, index) => (
                                        <AdvancedTableRow key={index}>
                                            <AdvancedTableCell>{project.ProjectName}</AdvancedTableCell>
                                            <AdvancedTableCell>{project.Location}</AdvancedTableCell>
                                            <AdvancedTableCell>
                                                {project.ProjectType === 'vacuum' ? 'Vacuum Station' :
                                                    project.ProjectType === 'vacuumPot' ? 'Vacuum & Pot Station' :
                                                        project.ProjectType === 'vacuumPotLora' ? 'Vacuum & Pot (LoRaWan) Station' :
                                                            project.ProjectType}
                                            </AdvancedTableCell>

                                            <AdvancedTableCell>
                                                {project.DeviceType === 'ewon' ? 'Ewon' : project.DeviceType === 'sunit' ? 'Sunit' : project.DeviceType}
                                            </AdvancedTableCell>

                                            <AdvancedTableCell>
                                                <Button
                                                    onClick={() => handleDetailViewClick(project.Customerid)}
                                                    style={{ textTransform: 'none' }}
                                                >
                                                    <img src={GoToLogin} alt="Go to login" style={{ width: '30px', height: '30px' }} />
                                                </Button>
                                            </AdvancedTableCell>
                                        </AdvancedTableRow>
                                    ))
                                ) : (
                                    <AdvancedTableRow>
                                        <AdvancedTableCell colSpan={6}>Loading...</AdvancedTableCell>
                                    </AdvancedTableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </AdvancedCard>
            </ContentContainer>

            <Dialog open={openModal} onClose={handleModalClose} maxWidth="lg" fullWidth>
                <DialogTitle
                    style={{
                        backgroundColor: '#1E90FF',
                        color: '#fff',
                        fontWeight: 'bold',
                        padding: '1rem',
                        textAlign: 'center',
                        position: 'relative',
                    }}>
                    Super Admin Settings
                    <IconButton
                        onClick={handleModalClose}
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            color: '#fff'
                        }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent style={{ backgroundColor: '#fff', padding: '2rem', overflowY: 'auto' }}>
                    <Grid container spacing={4}>
                        {/* User Information Column */}
                        <Grid item xs={12} md={4}>
                            <Box
                                style={{
                                    backgroundColor: '#fff',
                                    padding: '2rem',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                                }}>
                                <Typography variant="h5" style={{ color: '#1E90FF', fontWeight: '600', textAlign: 'center' }}>
                                    User Information
                                </Typography>
                                <Typography variant="body1" style={{ marginTop: '1rem', color: '#000' }}>
                                    <strong>Email:</strong> {loggedInUser?.email}
                                </Typography>
                                <Typography variant="body1" style={{ marginTop: '0.5rem', color: '#000' }}>
                                    <strong>Contact:</strong> {loggedInUser?.Contact || "NA"}
                                </Typography>
                                <Typography variant="body1" style={{ marginTop: '0.5rem', color: '#000' }}>
                                    <strong>Role:</strong>
                                    {loggedInUser?.RoleID == "1" ? " Super Admin" :
                                        loggedInUser?.RoleID == "2" ? " Admin" :
                                            loggedInUser?.RoleID == "3" ? " User" : " Unknown"}
                                </Typography>

                                <Typography variant="body1" style={{ marginTop: '0.5rem', color: '#000' }}>
                                    <strong>Email Enabled:</strong>
                                    <Switch
                                        checked={editedData.EmailEnabled}
                                        onChange={() => setEditedData(prev => ({ ...prev, EmailEnabled: !prev.EmailEnabled }))}
                                        color="primary"
                                        disabled={!isEditMode}
                                    />
                                </Typography>

                                <Typography variant="body1" style={{ marginTop: '0.5rem', color: '#000' }}>
                                    <strong>SMS Enabled:</strong>
                                    <Switch
                                        checked={editedData.SmsEnabled}
                                        onChange={() => setEditedData(prev => ({ ...prev, SmsEnabled: !prev.SmsEnabled }))}
                                        color="primary"
                                        disabled={!isEditMode}
                                    />
                                </Typography>
                            </Box>
                        </Grid>

                        {/* Projects Email Service Column */}
                        <Grid item xs={12} md={4}>
                            <Box
                                style={{
                                    backgroundColor: '#fff',
                                    padding: '2rem',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                                }}>
                                <Typography variant="h5" style={{ color: '#1E90FF', fontWeight: '600', textAlign: 'center' }}>
                                    Projects Email Service
                                </Typography>

                                {editedData.projectsEmailService?.map((project, index) => (
                                    <Box key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                                        <Typography
                                            style={{
                                                flex: 1,
                                                fontWeight: '500',
                                                color: '#000',
                                                fontSize: '16px'
                                            }}>
                                            {project.ProjectName}
                                        </Typography>
                                        <Switch
                                            checked={project.EmailService}
                                            onChange={(e) => handleSwitchChange('email', index, e.target.checked)}
                                            color="primary"
                                            disabled={!isEditMode}
                                        />
                                    </Box>
                                ))}
                            </Box>
                        </Grid>

                        {/* Projects SMS Service Column */}
                        <Grid item xs={12} md={4}>
                            <Box
                                style={{
                                    backgroundColor: '#fff',
                                    padding: '2rem',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                                }}>
                                <Typography variant="h5" style={{ color: '#1E90FF', fontWeight: '600', textAlign: 'center' }}>
                                    Projects SMS Service
                                </Typography>

                                {editedData.projectsSmsService?.map((project, index) => (
                                    <Box key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                                        <Typography
                                            style={{
                                                flex: 1,
                                                fontWeight: '500',
                                                color: '#000',
                                                fontSize: '16px'
                                            }}>
                                            {project.ProjectName}
                                        </Typography>
                                        <Switch
                                            checked={project.SmsService}
                                            onChange={(e) => handleSwitchChange('sms', index, e.target.checked)}
                                            color="primary"
                                            disabled={!isEditMode}
                                        />
                                    </Box>
                                ))}
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>

                {/* Sticky Bottom Action Buttons */}
                <DialogActions style={{ position: 'sticky', bottom: 0, backgroundColor: '#fff', padding: '1rem' }}>
                    {isEditMode && (
                        <Box style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ marginRight: '1rem' }}
                                onClick={handleSaveClick}>
                                Save
                            </Button>
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={handleCancelClick}>
                                Cancel
                            </Button>
                        </Box>
                    )}
                    {!isEditMode && (
                        <Box style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleEditClick}>
                                Update
                            </Button>
                        </Box>
                    )}
                </DialogActions>
            </Dialog>
            <Footer />
            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
        </div>
    );
};

export default MasterDashboard;